import React from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import Home from "../components/Home";
import Login from "../components/Registration/Login";
import Signup from "../components/Registration/Signup";
import Terms from "../components/Terms";
import NotFound from "../components/ErrorHandler/NotFound";
import { ROUTES } from "../constant/Routes";
import AddPakat from "../components/Laboratory/AddPakat/AddPakat";
import Inquiry from "../components/Inquiry/Inquiry";
import PacketNumbers from "../components/PacketNumbers/PacketNumbers";
import ManagePakat from "../components/Laboratory/ManagePakat/ManagePakat";

function RoutContainer() {
  const navigate = useNavigate();

  /*useEffect(() => {
    if (!authContext.auth) {
      navigate(ROUTES.LOGIN);
    }
  }, [uathContext.auth]);
  
  import * as DeviceInfo from "react-device-detect";
  const deviceInfo =
      DeviceInfo.deviceType +
      "|" +
      DeviceInfo.browserName +
      "|" +
      DeviceInfo.mobileVendor +
      "|" +
      DeviceInfo.mobileModel +
      "|" +
      DeviceInfo.osName +
      "|" +
      DeviceInfo.osVersion;
  
  */

  return (
    <Routes>
      <Route path={ROUTES.HOME} element={<Home />} />
      <Route path={ROUTES.LOGIN} element={<Login />} />
      <Route path={ROUTES.SIGNUP} element={<Signup />} />
      <Route path={ROUTES.ADDPAKAT} element={<ManagePakat />} />
      <Route path={ROUTES.INQUIRY} element={<Inquiry />} />
      <Route path={ROUTES.TERMS} element={<Terms />} />
      <Route path={ROUTES.BUY_PACKET_NUMBER} element={<PacketNumbers />} />
      <Route path={"/"} element={<Navigate to={ROUTES.INQUIRY} />} />
      <Route path={ROUTES.NOTHING} element={<Inquiry />} />
      {/* <Route path={ROUTES.NOTHING} element={<NotFound />} /> */}
    </Routes>
  );
}

export default RoutContainer;
